export default __webpack_public_path__ + "9da447f8d2ddc4359d2107066e453847.svg";